import React, { createContext, useState, useContext } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const USE_REMOTE_SERVER = true;

  const baseUrl = USE_REMOTE_SERVER
    ? 'https://brockdenbrown.cah.ucf.edu'
    : 'http://localhost:80/brockdenbrown';

  const USE_HASH_ROUTER = false;

  const buildLink = (pathWithParams = '') => {
    const path = pathWithParams.replace(/^\/+/, ''); // Remove leading slash
    return USE_HASH_ROUTER
      ? `#/${path}`
      : `/${path}`;
  };  

  const [numResults, setNumResults] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [docTitle, setDocTitle] = useState('');
  const [docAuthor, setDocAuthor] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [processedMetadata, setProcessedMetadata] = useState([]);
  const [isPrintView, setIsPrintView] = useState(false);
  const [isDocumentLoaded, setIsDocumentLoaded] = useState(false);

  return (
    <SearchContext.Provider
      value={{
        USE_REMOTE_SERVER,
        baseUrl,
        USE_HASH_ROUTER,
        buildLink,
        numResults,
        setNumResults,
        searchData,
        setSearchData,
        docTitle,
        setDocTitle,
        docAuthor,
        setDocAuthor,
        currentPage,
        setCurrentPage,
        processedMetadata,
        setProcessedMetadata,
        isPrintView,
        setIsPrintView,
        isDocumentLoaded,
        setIsDocumentLoaded,
      }}
    >
      {children}
    </SearchContext.Provider>
  );

};

export const useSearchContext = () => useContext(SearchContext);
